import { useState } from 'react'
import { useAuth } from '../auth/authContext'
import { useI18n } from '../i18n'
import { Button } from './Button'
import { Logo } from './Logo'

const SAFE_TOP = 'env(safe-area-inset-top, 0px)'
const HEADER_HEIGHT = 72

const navItems = [
  { label: 'Who We Are', href: 'https://economicdevelopmentfund.com/#who-we-are' },
  { label: 'What We Do', href: 'https://economicdevelopmentfund.com/#what-we-do' },
  { label: 'Our Results', href: 'https://economicdevelopmentfund.com/#our-results' },
  { label: 'Contact', href: 'https://economicdevelopmentfund.com/#contact' },
]

export const WEBSITE_HEADER_OFFSET = `calc(${SAFE_TOP} + ${HEADER_HEIGHT}px)`

export function WebsiteHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { logout } = useAuth()
  const { t } = useI18n()

  return (
    <header
      className="fixed inset-x-0 top-0 z-50 border-b border-gray-500 bg-white"
      style={{ paddingTop: SAFE_TOP }}
    >

      <div className="mx-auto flex h-[72px] w-full max-w-screen-sm items-center justify-between gap-4 px-4 md:max-w-4xl">
        <a
          href="https://economicdevelopmentfund.com/"
          aria-label="The Economic Development Fund"
          className="flex min-w-0 shrink-0 items-center gap-3"
        >
          <Logo width={64} height={24} />
          <span className="hidden text-[10px] font-bold uppercase leading-3 tracking-[0.08em] text-gray-900 min-[380px]:block">
            The Economic
            <br />
            Development Fund
          </span>
        </a>

        <div className="flex items-center gap-4">
          <nav aria-label="Economic Development Fund website" className="hidden md:block">
            <ul className="flex items-center gap-4">
              {navItems.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-xs font-bold uppercase text-gray-900"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Desktop account action. The marketing links are the only controls
              in this bar, and the Profile tab (where Log out otherwise lives)
              is not part of this shell. */}
          <div className="hidden md:block">
            <Button intent="outline" size="sm" onClick={logout}>
              {t('profile.logout')}
            </Button>
          </div>

          <button
            type="button"
            aria-label="Open website navigation"
            aria-expanded={isMenuOpen}
            className="flex size-10 flex-col items-center justify-center gap-1.5 md:hidden"
            onClick={() => setIsMenuOpen((open) => !open)}
          >
            <span className="h-0.5 w-6 bg-gray-900" />
            <span className="h-0.5 w-6 bg-gray-900" />
            <span className="h-0.5 w-6 bg-gray-900" />
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <nav
          aria-label="Economic Development Fund mobile website"
          className="border-t border-gray-500 bg-white md:hidden"
        >
          <ul className="mx-auto w-full max-w-screen-sm px-4 py-2">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className="block py-3 text-sm font-bold uppercase text-gray-900"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li className="py-3">
              <Button intent="outline" size="sm" fullWidth onClick={logout}>
                {t('profile.logout')}
              </Button>
            </li>
          </ul>
        </nav>
      )}
    </header>
  )
}

export function WebsiteHeaderSpacer() {
  return <div aria-hidden style={{ height: WEBSITE_HEADER_OFFSET }} />
}
